// Module
var code = "<svg width=\"33\" height=\"34\" viewBox=\"0 0 33 34\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <circle cx=\"16.5001\" cy=\"16.801\" r=\"16.233\" fill=\"white\"/> <path d=\"M22.9932 17.342L12.4417 23.4339L12.4417 11.2502L22.9932 17.342Z\" fill=\"#3B3B3B\"/> </svg> ";
// Exports
module.exports = code;